import React from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { useLocation, useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons/lib';
import styled from '@emotion/styled';

interface DeviceInfo {
  value:string;
  label:string;
}

const Devices:DeviceInfo[] = [
  { value: 'firetv', label: 'Amazon Fire TV' },
  { value: 'tvos', label: 'Apple TV' },
  { value: 'roku', label: 'Roku' },
  { value: 'samsung', label: 'Samsung' },
  { value: 'ps4', label: 'Playstation 4' },
  { value: 'ps3', label: 'Playstation 3' },
  { value: 'xboxone', label: 'Xbox One' },
  { value: 'xbox360', label: 'Xbox 360' },
  { value: 'chromecast', label: 'Chromecast' },
  { value: 'androidtv', label: 'Android TV' },
];

const getDeviceMenu = (select,selectedDevice) =>
  <Menu onClick={select} selectedKeys={selectedDevice} >
    {
      Devices.map(device =>
        <Menu.Item key={device.value}>
          {device.label}
        </Menu.Item>)
    }
  </Menu>;

export const DevicesDropDown = () => {
  const location = useLocation();
  const history = useHistory();
  const { type, tagId, device } = useParams<{type?: string, tagId?: string, device?: string}>();

  const onDeviceSelect = ({ key: deviceKey }) => {
    const newLocation = `/demo/preview/${type}/${tagId}/${deviceKey}${location.search}`;
    history.push(newLocation);
  };

  const deviceLavle = Devices.find(d => d?.value === device)?.label ||'Apple TV'  ;

  return <DropDownContainer>
    <Dropdown overlay={getDeviceMenu(onDeviceSelect,device)}>
      <Button style={dropdownButton}><p>{deviceLavle}</p> <DownOutlined/></Button>
    </Dropdown>
  </DropDownContainer>;
};

const dropdownButton = {
  borderRadius: "5px",
  display:"flex",
  justifyContent:"space-between",
  alignItems:"baseline"
};

const DropDownContainer = styled.div`
    position: absolute;
    width: 200px;
    right:2%;
    display: flex;
    align-self: center;
    flex-direction: column;
    font-family: proximanova-regular;
`;
